import { Alert, Stack, Typography } from "@merchant-trends/ds-ui";

/**
 * The portal's Home until NEX2-228 builds the Homepage: what the scaffold has always said, now
 * inside the Nexus frame (NEX2-232), whose `AppShell` supplies the page's `<main>` and padding.
 *
 * **No brand is activated yet.** `@merchant-trends/ds-tokens/css` keys every custom property off
 * `[data-brand]` and `[data-theme]`, and FE-04 makes the choice of those two values server-resolved
 * configuration - never a code branch, a hostname sniff, or a compiled default. The brand hook
 * arrives in a later NEX2-232 pull request; until then this renders on the browser's own defaults.
 *
 * **No request is made.** FE-06 forbids an API origin from reaching this bundle through
 * `import.meta.env`, and FE-08 routes browser traffic through the generated client in
 * `packages/contract`, which is still a manifest. A fetch here would have to break one of the two.
 */
export function HomeScreen() {
  return (
    <Stack direction="column" spacing={4}>
      <Typography component="h1" variant="h2">
        Nexus
      </Typography>
      <Typography variant="body1">
        This shell renders through <code>@merchant-trends/ds-ui</code>, on tokens published by{" "}
        <code>@merchant-trends/ds-tokens</code>. Nothing is copied from the prototype.
      </Typography>
      <Alert severity="info" title="Presentation is unbranded until a server selects one">
        Brand and colour scheme are server-resolved configuration, so this application does not
        choose them. Until the runtime configuration and the brand response land, the design
        system&rsquo;s custom properties have no <code>data-brand</code> to resolve against and
        components render on the browser&rsquo;s defaults.
      </Alert>
    </Stack>
  );
}
